(() => {
  if (customElements.get('pc-purchase-terms')) return;
  let queue = Promise.resolve();
  let revision = 0;
  class PurchaseTerms extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input');
      this.message = this.querySelector('[role="alert"]');
      this.input.addEventListener('change', () => {
        this.input.setCustomValidity('');
        this.syncProductButton();
        this.persist().catch(() => {});
      });
      if (this.dataset.context === 'product') this.setupProductButton();
    }
    setupProductButton() {
      const form = document.getElementById(this.dataset.formId);
      this.form = form;
      this.button = form ? form.querySelector('button[name="add"]') : null;
      if (!this.button) return;
      this.buttonLabel = this.button.querySelector('span') || this.button;
      // Si el producto está agotado, el tema ya deshabilita el botón: no lo tocamos.
      this.soldOut = this.button.disabled;
      this.addText = this.buttonLabel.textContent.trim();
      form.addEventListener('submit', event => {
        if (this.input.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.validate();
      }, true);
      this.syncProductButton();
    }
    syncProductButton() {
      if (!this.button || this.soldOut) return;
      const accepted = this.input.checked;
      this.button.disabled = !accepted;
      this.button.classList.toggle('pc-terms-pending', !accepted);
      this.buttonLabel.textContent = accepted ? this.addText : this.dataset.required;
      this.classList.toggle('pc-purchase-terms--pending', !accepted);
    }
    validate() {
      this.input.setCustomValidity(this.input.checked ? '' : this.dataset.required);
      return this.input.reportValidity();
    }
    persist() {
      const value = this.input.checked ? this.input.value : '';
      const currentRevision = ++revision;
      const task = queue.catch(() => {}).then(async () => {
        this.setAttribute('aria-busy', 'true');
        this.message.hidden = true;
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { pc_condiciones_compra: value } })
          });
          const cart = await response.json();
          if (!response.ok || (cart.attributes?.pc_condiciones_compra || '') !== value) throw new Error(this.dataset.error);
          if (currentRevision === revision) document.querySelectorAll('pc-purchase-terms[data-context="cart"]').forEach(element => {
            element.input.checked = Boolean(value);
            element.input.setCustomValidity('');
          });
        } catch (error) {
          this.message.textContent = this.dataset.error;
          this.message.hidden = false;
          throw error;
        } finally {
          this.removeAttribute('aria-busy');
        }
      });
      queue = task;
      return task;
    }
  }
  customElements.define('pc-purchase-terms', PurchaseTerms);
  const replay = new WeakSet();
  const pending = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (event.submitter?.name !== 'checkout') return;
    if (replay.has(form)) { replay.delete(form); return; }
    const terms = Array.from(document.querySelectorAll('pc-purchase-terms[data-context="cart"]')).find(element => element.dataset.formId === form.id);
    if (!terms) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form) || !terms.validate()) return;
    pending.add(form);
    const button = event.submitter;
    try {
      await terms.persist();
      if (!terms.validate()) return;
      replay.add(form);
      form.requestSubmit(button);
    } catch (error) {
      terms.input.focus();
    } finally {
      pending.delete(form);
    }
  }, true);
})();
